import { UserRole } from "./userRole";

interface CandidateRejectReason {
    id: number;
    description: string;
}

export class CandidateRejectedReasonType {
    readonly id: number;
    readonly description: string;
    readonly roles: UserRole[];

    constructor(
        reasonId: number,
        reasonDescription: string,
        roles: UserRole[]
    ) {
        this.id = reasonId;
        this.description = reasonDescription;
        this.roles = roles;
    }

    public static UnableToContact = new CandidateRejectedReasonType(
        1,
        "Unable to contact",
        [
            UserRole.Accounting,
            UserRole.Administrator,
            UserRole.Client,
            UserRole.ClientAdmin,
            UserRole.Recruiter,
            UserRole.Sourcer,
        ]
    );
    public static NotQualified = new CandidateRejectedReasonType(
        2,
        "Not qualified",
        [
            UserRole.Accounting,
            UserRole.Administrator,
            UserRole.Client,
            UserRole.ClientAdmin,
            UserRole.Recruiter,
            UserRole.Sourcer,
            UserRole.Networker,
        ]
    );
    public static JobClosed = new CandidateRejectedReasonType(3, "Job closed", [
        UserRole.Accounting,
        UserRole.Administrator,
        UserRole.Client,
        UserRole.ClientAdmin,
        UserRole.Recruiter,
        UserRole.Sourcer,
    ]);
    public static AcceptedAnotherOpp = new CandidateRejectedReasonType(
        4,
        "Accepted another opportunity",
        [
            UserRole.Accounting,
            UserRole.Administrator,
            UserRole.Client,
            UserRole.ClientAdmin,
            UserRole.Recruiter,
            UserRole.Sourcer,
            UserRole.Networker,
        ]
    );
    public static NoLongerSeeking = new CandidateRejectedReasonType(
        5,
        "No longer seeking new positions",
        [
            UserRole.Accounting,
            UserRole.Administrator,
            UserRole.Client,
            UserRole.ClientAdmin,
            UserRole.Recruiter,
            UserRole.Sourcer,
            UserRole.Networker,
        ]
    );
    public static UnmetExpectations = new CandidateRejectedReasonType(
        6,
        "Does not meet candidate's expectations",
        [
            UserRole.Accounting,
            UserRole.Administrator,
            UserRole.Client,
            UserRole.ClientAdmin,
            UserRole.Recruiter,
            UserRole.Sourcer,
            UserRole.Networker,
        ]
    );
    public static AlreadyAppliedDirectly = new CandidateRejectedReasonType(
        7,
        "Already applied",
        [
            UserRole.Accounting,
            UserRole.Administrator,
            UserRole.Client,
            UserRole.ClientAdmin,
            UserRole.Recruiter,
            UserRole.Sourcer,
            UserRole.Networker,
        ]
    );
    public static CurrentEmployeeOfClient = new CandidateRejectedReasonType(
        8,
        "Already employed",
        [
            UserRole.Accounting,
            UserRole.Administrator,
            UserRole.Client,
            UserRole.ClientAdmin,
            UserRole.Recruiter,
            UserRole.Sourcer,
        ]
    );
    public static NoHealthcareExperience = new CandidateRejectedReasonType(
        9,
        "No healthcare experience",
        [
            UserRole.Accounting,
            UserRole.Administrator,
            UserRole.Client,
            UserRole.ClientAdmin,
            UserRole.Recruiter,
            UserRole.Sourcer,
            UserRole.Networker,
        ]
    );
    public static UnmetClientExpectations = new CandidateRejectedReasonType(
        10,
        "Does not meet client's expectations",
        [
            UserRole.Accounting,
            UserRole.Administrator,
            UserRole.Client,
            UserRole.ClientAdmin,
            UserRole.Recruiter,
            UserRole.Sourcer,
        ]
    );
    public static InaccurateProfile = new CandidateRejectedReasonType(
        11,
        "Inaccurate profile",
        [
            UserRole.Accounting,
            UserRole.Administrator,
            UserRole.Client,
            UserRole.ClientAdmin,
        ]
    );
    public static DoesNotKnowRecruiter = new CandidateRejectedReasonType(
        12,
        "Does not know Recruiter",
        [
            UserRole.Accounting,
            UserRole.Administrator,
            UserRole.Client,
            UserRole.ClientAdmin,
        ]
    );
    public static NoShow = new CandidateRejectedReasonType(13, "No show", [
        UserRole.Accounting,
        UserRole.Administrator,
        UserRole.Client,
        UserRole.ClientAdmin,
    ]);

    public static asArray = () => [
        CandidateRejectedReasonType.UnableToContact,
        CandidateRejectedReasonType.NotQualified,
        CandidateRejectedReasonType.JobClosed,
        CandidateRejectedReasonType.AcceptedAnotherOpp,
        CandidateRejectedReasonType.NoLongerSeeking,
        CandidateRejectedReasonType.UnmetExpectations,
        CandidateRejectedReasonType.AlreadyAppliedDirectly,
        CandidateRejectedReasonType.CurrentEmployeeOfClient,
        CandidateRejectedReasonType.NoHealthcareExperience,
        CandidateRejectedReasonType.UnmetClientExpectations,
        CandidateRejectedReasonType.InaccurateProfile,
        CandidateRejectedReasonType.DoesNotKnowRecruiter,
        CandidateRejectedReasonType.NoShow,
    ];

    public static availableReasons = (
        role: UserRole,
        isNoShowRejectionReasonEligible: boolean
    ): CandidateRejectReason[] => {
        // look up reject reasons for this role
        const reasons = CandidateRejectedReasonType.asArray().filter(x =>
            x.roles.find(ur => ur.roleId === role.roleId) ? true : false
        );

        // only include no show if in list
        if (!isNoShowRejectionReasonEligible) {
            return reasons.filter(
                x => x.id !== CandidateRejectedReasonType.NoShow.id
            );
        }

        return reasons;
    };

    public static fromId = (id: number) =>
        CandidateRejectedReasonType.asArray().find(t => t.id === id);
}
